import React, { useState } from 'react';

import { API } from 'constants';
import client from '../../../../services/template-api';

import { generateUUID } from '../../../../helpers/generateUUID';
import { updateOrderKeys } from '../../../../helpers/insertItemAtSpecificPositionWithOrderUpdate';

import { defaultErrorMessage } from '../../../../constants/errorMessages';

import ConfirmDeletionModalPattern from '../../../../design-system/ConfirmDeletionModalPattern/ConfirmDeletionModalPattern';

const DeleteStepModal = ({
    name,
    temporaryId,
    allSteps,
    setSteps,
    playbookTemplateId,
    onClose,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorAlert, setErrorAlert] = useState(null);

    const handleDelete = async () => {
        try {
            setIsLoading(true);
            const filteredSteps = allSteps.filter((step) => step.temporaryId !== temporaryId);
            const filteredStepsWithUpdatedOrders = updateOrderKeys(filteredSteps);

            const temporaryIdMap = new Map(
                filteredStepsWithUpdatedOrders.map((step) => [
                    step.order + step.name,
                    step.temporaryId || generateUUID(),
                ])
            );

            const requestBody = {
                steps: filteredStepsWithUpdatedOrders.map(({ temporaryId, ...step }) => step),
            };

            const { data } = await client.patch(
                API.ROUTES.template.playbookTemplate + playbookTemplateId + '/',
                requestBody
            );

            setSteps(() => {
                const stepsFromResponse = data.default_version?.steps || [];
                const stepsWithTemporaryIds = stepsFromResponse.map((item) => {
                    const key = item.order + item.name;
                    const temporaryId = temporaryIdMap.get(key) || generateUUID();
                    return { ...item, temporaryId };
                });

                return stepsWithTemporaryIds.sort((a, b) => a.order - b.order);
            });

            onClose();
        } catch (error) {
            setErrorAlert({ message: defaultErrorMessage, statusCode: error.response?.status });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <ConfirmDeletionModalPattern
            title="Delete Step"
            handleDelete={handleDelete}
            onClose={onClose}
            confirmationTextStart="Are you sure you want to delete the"
            confirmationTextEnd="Step?"
            entityName={name}
            errorAlert={errorAlert}
            isLoading={isLoading}
            setErrorAlert={setErrorAlert}
        />
    );
};

export default DeleteStepModal;
